export default "__VITE_PUBLIC_ASSET__5d7fa0ac__"